import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import PageSEO from "../../utils/PageSEO";
import { useTranslation } from "../../i18n";
import houseRentImg from "../../Assets/houserent.png";
import rideMateImg from "../../Assets/ridemate.png";

function Projects() {
  const { t } = useTranslation();
  const items = t("projects.items");
  const imageMap = {
    "house-rent": houseRentImg,
    "ridemate": rideMateImg,
  };

  const projectsStructuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://yuvasree.online/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Projects",
        "item": "https://yuvasree.online/project"
      }
    ]
  };

  return (
    <>
      <PageSEO
        title="Projects | Yuvasree Padmanabhan | Full Stack Development & Automation"
        description="Explore Yuvasree's portfolio projects including House Rent Management System, Ridemate Car Rental Booking Platform, and more. Built with React, Node.js, JavaScript, and modern web technologies."
        keywords="Yuvasree projects, full stack projects, car rental system, house management system, React projects, Node.js projects, web development portfolio, GitHub projects"
        url="https://yuvasree.online/project"
        structuredData={projectsStructuredData}
      />
      <Container fluid className="project-section">
        <Particle />
        <Container>
        <h1 className="project-heading">
          {t("projects.title")}{" "}
          <strong className="purple">{t("projects.titleHighlight")} </strong>
        </h1>
        <p style={{ color: "white" }}>{t("projects.subtitle")}</p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {Array.isArray(items) &&
            items.map((project) => (
              <Col xs={12} lg={6} className="project-card" key={project.id}>
                <ProjectCard
                  imgPath={imageMap[project.id]}
                  title={project.title}
                  description={
                    <>
                      <strong>{t("projects.technologiesUsed")}</strong>{" "}
                      {project.technologies}
                      <br />
                      <br />
                      {project.paragraphs.map((para) => (
                        <React.Fragment key={para}>
                          {para}
                          <br />
                          <br />
                        </React.Fragment>
                      ))}
                    </>
                  }
                />
              </Col>
            ))}
        </Row>
      </Container>
    </Container>
    </>
  );
}

export default Projects;
